import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import CustomerMaster from "./CustomerMaster";
import CustomerExternalIds from "./CustomerExternalIds";

const CustomerTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Set initial active tab based on current route
  const getInitialTab = () => {
    if (location.pathname.includes('customer-external-ids')) {
      return 'customer-external-ids';
    }
    return 'customer-master';
  };

  const [key, setKey] = useState(getInitialTab());

  return (
    <div className="customer-tabs-container">
      <Tabs
        id="customer-tabs"
        activeKey={key}
        onSelect={(k) => {
          setKey(k);
          navigate(`/${k}`);
        }}
        className="mb-4 custom-tabs"
      >
        <Tab 
          eventKey="customer-master" 
          title={<span className={key === 'customer-master' ? 'active-tab' : ''}>Customer Master</span>}
          className="customer-tab-content"
        >
          <CustomerMaster />
        </Tab>
        {/* <Tab 
          eventKey="customer-external-ids" 
          title={<span className={key === 'customer-external-ids' ? 'active-tab' : ''}>External IDs</span>}
          className="customer-tab-content"
        >
          <CustomerExternalIds />
        </Tab> */}
      </Tabs>
    </div>
  );
};

export default CustomerTabs;